import CssBaseline from '@mui/material/CssBaseline';
import { Experimental_CssVarsProvider as CssVarsProvider } from '@mui/material/styles';
import { StyledEngineProvider } from '@mui/material/styles';
import { useSettingsContext } from '../settings';
import { useColorScheme } from '@mui/material/styles';

import { createTheme } from './create-theme';
import { schemeConfig } from './scheme-config';
import { useEffect } from 'react';

// ----------------------------------------------------------------------

export function ThemeProvider({ children, userTheme }) {
  const settings = useSettingsContext();

  const theme = createTheme(settings);

  return (
    <CssVarsProvider theme={theme} defaultMode={schemeConfig.defaultMode} modeStorageKey={schemeConfig.modeStorageKey}>
      <StyledEngineProvider injectFirst>
        <CssBaseline />
        <Switch userTheme={userTheme} />
        {children}
      </StyledEngineProvider>
    </CssVarsProvider>
  );
}

function Switch({ userTheme }) {
  const { setMode } = useColorScheme();

  useEffect(() => {
    if (!userTheme) return;
    setMode(userTheme.mode);
  }, [userTheme, setMode]);

  return <></>;
}
